import { match } from 'ts-pattern';

import { BlockLegalTextType } from '../../models/Content';
import { BlockLegalTextBackgroundColor, BlockLegalTextContent, BlockLegalTextTextColor } from './model';

export const transformBlockLegalText = (content: BlockLegalTextType): BlockLegalTextContent => {
    const background = match<BlockLegalTextType['fields']['colorOption'], BlockLegalTextBackgroundColor>(
        content.fields.colorOption,
    )
        .with('white', () => 'primary')
        .with('gray', () => 'secondary')
        .with('primary', () => 'tone-on-tone-primary')
        .with('secondary', () => 'tone-on-tone-secondary')
        .with('tertiary', () => 'tone-on-tone-quaternary')
        .with('primary-negative', () => 'tone-on-tone-primary')
        .otherwise(() => 'primary');

    const textColor = match<BlockLegalTextType['fields']['colorOption'], BlockLegalTextTextColor>(
        content.fields.colorOption,
    )
        .with('white', () => 'default')
        .with('gray', () => 'default')
        .with('primary', () => 'tone-on-tone-primary')
        .with('secondary', () => 'tone-on-tone-secondary')
        .with('tertiary', () => 'tone-on-tone-tertiary')
        .with('primary-negative', () => 'medium-negative')
        .otherwise(() => 'default');

    const isNegative = content.fields.colorOption === 'primary' || content.fields.colorOption === 'primary-negative';

    return {
        id: content.sys.id,
        title: content.fields.title,
        description: content.fields.legalText?.fields.description || null,
        background,
        textColor,
        isNegative,
        isExpandable: content.fields.displayOption === 'expandable',
    };
};
